import axios from 'axios';

const state = {
    shops: [],
    currentShop: null,
    dashboard: null,
};

const getters = {
    shops: state => state.shops,
    currentShop: state => state.currentShop,
    dashboard: state => state.dashboard,
};

const actions = {
    shop_list({ commit }, data) {
        return axios.get('shops', { params: data }).then(r => {
            commit("SET_SHOPS", r.data.data.shops); return r;
        });
    },
    shop_create({ commit }, data) {
        return axios.post('shop', data).then(r => {
            commit("ADD_SHOP", r.data.data.shop); return r;
        });
    },
    shop_update({ commit }, data) {
        return axios.put('shops/' + data.id, data).then(r => {
            commit("UPDATE_SHOP", r.data.data.shop); return r;
        });
    },
    shop_detail({ commit }, id) {
        return axios.get('shops/' + id).then(r => {
            commit("SET_CURRENT_SHOP", r.data.data.shop); return r;
        });
    },
    shop_delete({ commit }, id) {
        return axios.delete('shops/' + id).then(r => {
            commit("REMOVE_SHOP", id); return r;
        });
    },
    shop_check_slug(_, slug) {
        return axios.get('shop/check-slug/' + slug);
    },
    // === Phase 1 extensions ===
    shop_dashboard({ commit }, id) {
        return axios.get('shops/' + id + '/dashboard').then(r => {
            commit("SET_DASHBOARD", r.data.data); return r;
        });
    },
    shop_statistics(_, { id, period }) {
        return axios.get('shops/' + id + '/statistics', { params: { period: period || '30' } });
    },
    shop_notification_log(_, { shopId, params }) {
        return axios.get('shops/' + shopId + '/notification-log', { params });
    },
    shop_update_settings(_, { id, settings }) {
        return axios.put('shops/' + id + '/settings', settings);
    },
    shop_get_settings(_, id) {
        return axios.get('shops/' + id + '/settings');
    },
    shop_test_email(_, { id, recipient }) {
        return axios.post('shops/' + id + '/test-email', recipient ? { recipient } : {});
    },
    shop_verify_domain(_, id) {
        return axios.post('shops/' + id + '/verify-domain');
    },
    shop_broadcast(_, { id, payload }) {
        return axios.post('shops/' + id + '/broadcast', payload);
    },
};

const mutations = {
    SET_SHOPS(state, shops) { state.shops = shops; },
    ADD_SHOP(state, shop) { state.shops.unshift(shop); },
    UPDATE_SHOP(state, shop) {
        const i = state.shops.findIndex(s => s.id === shop.id);
        if (i !== -1) state.shops.splice(i, 1, shop);
    },
    REMOVE_SHOP(state, id) { state.shops = state.shops.filter(s => s.id !== id); },
    SET_CURRENT_SHOP(state, shop) { state.currentShop = shop; },
    SET_DASHBOARD(state, data) { state.dashboard = data; },
};

export default { namespaced: true, state, getters, actions, mutations };
